import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "row mb-6" }
const _hoisted_12 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_13 = { class: "col-lg-8 fv-row" }
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_18 = { class: "col-lg-8 fv-row" }
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "row mb-6" }
const _hoisted_22 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_23 = { class: "col-lg-8 fv-row d-flex align-items-center pt-3" }
const _hoisted_24 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_25 = {
  class: "form-check-label",
  for: "isActive"
}
const _hoisted_26 = { class: "row mb-6" }
const _hoisted_27 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_28 = { class: "col-lg-8 fv-row d-flex align-items-center pt-3" }
const _hoisted_29 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_30 = {
  class: "form-check-label",
  for: "disablePriceAreas"
}
const _hoisted_31 = { class: "row mb-6" }
const _hoisted_32 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_33 = { class: "col-lg-8 fv-row d-flex align-items-center pt-3" }
const _hoisted_34 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_35 = {
  class: "form-check-label",
  for: "disableVolumeAreas"
}
const _hoisted_36 = { class: "row mb-6" }
const _hoisted_37 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_38 = { class: "col-lg-8 fv-row d-flex align-items-center pt-3" }
const _hoisted_39 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_40 = {
  class: "form-check-label",
  for: "volumeIndexTicker"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-8" }, null, -1)
const _hoisted_42 = { class: "mb-6" }
const _hoisted_43 = { class: "fw-bolder mb-1" }
const _hoisted_44 = { class: "text-muted fs-7" }
const _hoisted_45 = { class: "row mb-6" }
const _hoisted_46 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_47 = { class: "col-lg-8 fv-row d-flex align-items-center pt-3" }
const _hoisted_48 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_49 = { class: "row mb-6" }
const _hoisted_50 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_51 = { class: "col-lg-8 fv-row d-flex align-items-center pt-3" }
const _hoisted_52 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_53 = { class: "row mb-6" }
const _hoisted_54 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_55 = { class: "col-lg-8 fv-row d-flex align-items-center pt-3" }
const _hoisted_56 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_57 = { class: "row mb-6" }
const _hoisted_58 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_59 = { class: "col-lg-8 fv-row d-flex align-items-center pt-3" }
const _hoisted_60 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_61 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_62 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_63 = { class: "indicator-label" }
const _hoisted_64 = { class: "indicator-progress" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('update', 'indices'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateIndicesPropertyCategory')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate,
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('slug')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('indicesPropertyCategorySlugHint'),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.slug) = $event))
                    }, null, 8, _hoisted_10), [
                      [
                        _vModelText,
                        _ctx.item.slug,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.translate('titleAr')), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('titleAr'),
                      modelValue: _ctx.item.titleAr,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.titleAr) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.translate('titleEn')), 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('titleEn'),
                      modelValue: _ctx.item.titleEn,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.titleEn) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.translate('isActive')), 1),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "isActive",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.isActive) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.item.isActive]
                      ]),
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.translate('indicesPropertyCategoryActiveHint')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.translate('disablePriceAreas')), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "disablePriceAreas",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.disablePriceAreas) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.item.disablePriceAreas]
                      ]),
                      _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.translate('disablePriceAreasHint')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.translate('disableVolumeAreas')), 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "disableVolumeAreas",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.disableVolumeAreas) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.item.disableVolumeAreas]
                      ]),
                      _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.translate('disableVolumeAreasHint')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.translate('volumeIndexTicker')), 1),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "volumeIndexTicker",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.item.volume_index_ticker) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.item.volume_index_ticker]
                      ]),
                      _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.translate('volumeIndexTickerHint')), 1)
                    ])
                  ])
                ]),
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("h4", _hoisted_43, _toDisplayString(_ctx.translate('appViews')), 1),
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.translate('appViewsHint')), 1)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.translate('priceIndexView')), 1),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "price_index_view_active",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item.price_index_view_active) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.item.price_index_view_active]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.translate('volumeIndexView')), 1),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "volume_index_view_active",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.volume_index_view_active) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.item.volume_index_view_active]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.translate('ppmView')), 1),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "ppm_view_active",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.ppm_view_active) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.item.ppm_view_active]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.translate('noOfDealsView')), 1),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "no_of_deals_view_active",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.item.no_of_deals_view_active) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.item.no_of_deals_view_active]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_62, [
                  _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_64, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_65
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}